/*

    <warehouse-location-selector
      [locationID]="string|null default value"
      [label]="input field label label 'Location ID'"
      [placeholder]"input field placeholder text"      
      [validLocations]="string[]"
      (onLocationIDEntered)="onLocationEntered($event)">
    </warehouse-location-selector>
*/

import { Component, ElementRef, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialog } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'warehouse-location-selector',
  templateUrl: './warehouse-location-selector.component.html',
  styleUrls: ['./warehouse-location-selector.component.css']
})
export class WarehouseLocationSelectorComponent {

  @Input() locationID: string | null = null;
  @Output() onLocationIDEntered = new EventEmitter<string>();

  @Input() label: string = "Location ID";
  @Input() validLocations?: string[];
  @Input() placeholder: string = '';
  @Input() disabled: boolean = false;

  @ViewChild('locationInput') private locationInput!: ElementRef<any>;

  constructor(private dialog: MatDialog) { }

  onLocationEntered(locationID: string | number | null) {
    this.locationID = locationID == null ? null : locationID.toString().toUpperCase();

    if (this.validLocations && !this.validLocations.contains(this.locationID)) {
      this.dialog.open(AlertDialog, { data: { message: "Invalid Warehouse Location ID", buttonText: 'OK' } }).afterClosed().subscribe(() => {
        this.locationID = null;
        setTimeout(() => (<any>this.locationInput.nativeElement).focus(), 100);
      });
      return;
    }

    this.onLocationIDEntered.emit(this.locationID || '');
  }

  focus() {
    setTimeout(() => {
      (<any>this.locationInput.nativeElement).focus();
    });
  }
}
